module.exports = __webpack_public_path__ + "assets/img/logo.dab049b.png";


//////////////////
// WEBPACK FOOTER
// ./static/logo.png
// module id = 374
// module chunks = 1